import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ResultColumnHeadTextFormElement.less';


class ResultColumnHeadTextFormElement extends Component {
    render() {
        const text = this.props.children;

        return (
            <span
                onClick={this.props.onClick}
                className={`result-column-head-text-form-element ${this.props.isSelected ? 'result-column-head-text-form-element-selected' : ''}`}
                title={text}
                dangerouslySetInnerHTML={{__html: text}}
            />
        )
    }
}

ResultColumnHeadTextFormElement.propTypes = {
  isSelected: PropTypes.bool,
  children: PropTypes.string,
  onClick: PropTypes.func,
};

ResultColumnHeadTextFormElement.defaultProps = {
  isSelected: false,
  children: '',
  onClick: () => {
  }
};


export default ResultColumnHeadTextFormElement;



// WEBPACK FOOTER //
// ./src/components/search/FormElements/ResultColumnHeadTextFormElement/ResultColumnHeadTextFormElement.js